import { Language } from '@/i18n/i18n.types';

import { SerializedPlainDate } from '@models/api/data.types';
import { Resident } from '@models/Resident';

import { AGREEMENTS_API_BASE_URL, API_BASE_URL } from './api.constants';
import { generateApiUrl } from './api.utils';
import { authClient } from './client.api';

export interface OccupantBasePayload {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  language?: Language;
}

export interface AddOccupantPayload extends OccupantBasePayload {
  ssn: string;
}

export interface UpdateOccupantPayload extends OccupantBasePayload {
  occupantId: string;
}

export const RESIDENT_API_URLS = {
  FETCH_RESIDENTS: `${API_BASE_URL}residents/:contractId`,
  ADD_RESIDENT: `${AGREEMENTS_API_BASE_URL}/occupants/add`,
  UPDATE_RESIDENT: `${AGREEMENTS_API_BASE_URL}/occupants/update`,
  REMOVE_RESIDENT: `${AGREEMENTS_API_BASE_URL}/occupants/remove`,
  INVITE_RESIDENT: `${AGREEMENTS_API_BASE_URL}/occupants/invite`,
} as const;

export const residentsApi = {
  fetchResidents: (contractId: string) =>
    authClient.get<Resident[]>(
      generateApiUrl(RESIDENT_API_URLS.FETCH_RESIDENTS, { contractId })
    ),

  addResident: (payload: {
    contractId: string;
    /** Occupant data. `undefined` for an anonymous occupant */
    occupant: AddOccupantPayload | undefined;
    beginDate: SerializedPlainDate;
    endDate?: SerializedPlainDate;
    inviteToOmaSATO?: boolean;
  }) =>
    authClient.post<{ occupantId: string }>(
      RESIDENT_API_URLS.ADD_RESIDENT,
      payload
    ),

  updateResident: (payload: {
    contractId: string;
    occupant: UpdateOccupantPayload;
    inviteToOmaSATO?: boolean;
  }) =>
    authClient.post<{ occupantId: string }>(
      RESIDENT_API_URLS.UPDATE_RESIDENT,
      payload
    ),

  removeResident: (payload: {
    contractId: string;
    occupantId: string;
    endDate: SerializedPlainDate;
  }) =>
    authClient.post<{
      occupantId: string;
      endDate: SerializedPlainDate;
    }>(RESIDENT_API_URLS.REMOVE_RESIDENT, payload),

  inviteResidentToOmaSATO: (payload: {
    occupantId: string;
    contractId: string;
  }) =>
    authClient.post<{ occupantId: string }>(
      RESIDENT_API_URLS.INVITE_RESIDENT,
      payload
    ),
};
